<div class="video-container" *ngIf="!isError">
    <video #video id="video" [width]="width" [height]="height" autoplay muted playsinline></video>
</div>
<div *ngIf="isError" class="error-block capture-item " [ngStyle]="{ width: width+'px', height: height+'px' }">
    <i class="icon-exclamation_mark_circled"></i>
    Camera disabled by browser. Please change settings for this site.
</div>
